import { createContext, type FC, type JSX, useContext } from "react";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import { useDynamicSegmentCounts } from "../../segment/hooks/use-dynamic-segment-counts";

type LexicalDynamicContextType = {
  segmentCounts: UseSupabaseLoaderState<Record<string, { name: string; count: number }>>;
};

const LexicalContext = createContext<LexicalDynamicContextType | null>(null);

export const LexicalDynamicContentContextProvider: FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const segmentCounts = useDynamicSegmentCounts();

  return <LexicalContext.Provider value={{ segmentCounts }}>{children}</LexicalContext.Provider>;
};

export const useLexicalDynamicContentContext = (): LexicalDynamicContextType => {
  const context = useContext(LexicalContext);
  if (!context) {
    throw new Error("useLexicalContext must be used within a LexicalContextProvider");
  }
  return context;
};
